import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Module store
import auth from '@/modules/auth/store'
import profile from '@/modules/profile/store'
import home from '@/modules/home/store'

export default createStore({

  modules: {
    auth,
    profile,
    home
  },
  plugins: [
    createPersistedState({ key: 'vuex', storage: window.localStorage || window.sessionStorage })
  ],
})
